import React, { useEffect, useMemo } from "react";

import { BellNotificationsBlock } from "@remar/shared/dist/components/Notifications";
import { NotificationDeliveryMethodEnum } from "@remar/shared/dist/models";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	getNotificationFullState,
	getUserNotifications,
	markAsRead
} from "store/features/notifications/notifications.slice";

import { routes } from "core/constants";

const BellNotifications = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { bellNotifications: bellNotificationsState } = useSelector(getNotificationFullState);

	useEffect(() => {
		dispatch(
			getUserNotifications({
				filters: {
					"notification.deliveryMethod": NotificationDeliveryMethodEnum.Socket
				}
			})
		);
	}, [dispatch]);

	const bellNotifications = useMemo(() => {
		if (!bellNotificationsState?.items) return [];

		return bellNotificationsState.items.reduce((acc, b) => {
			const insertIndex = acc.findIndex(item => new Date(b.createdAt).getTime() > new Date(item.createdAt).getTime());
			const enhanced = {
				...b,
				action:
					b.notification.title === "AdminCommentsNotification"
						? () => history.push(`${routes.lesson.getPath()}/${b?.data!.lessonId}`)
						: undefined
			};

			if (insertIndex === -1) {
				acc.push(enhanced);
			} else {
				acc.splice(insertIndex, 0, enhanced);
			}

			return acc;
		}, []);
	}, [bellNotificationsState?.items, history]);

	return <BellNotificationsBlock bellNotifications={bellNotifications} markAsRead={() => dispatch(markAsRead())} />;
};

export default BellNotifications;
